<template>
  <div class="language-menu" v-show="isOpen">
    <div class="language-btns">
      <div class="language-btn"
           v-for="lang in langs"
           :key="lang.short"
           @click="changeLanguage(lang.short)">
        <div class="language-btn__image"
             :class="['language-btn__image--' + lang.short]"></div>
        <div class="language-btn__text">
          {{  lang.long }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'languageMenu',
  components: {},
  data () {
    return {}
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    langs: {
      type: Array
    }
  },
  methods: {
    changeLanguage (language) {
      // Current filter var
      // const currentFilter = event.currentTarget
      this.$root.$i18n.locale = language

      this.$emit('hideLanguageMenu')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.language-menu {
  width: 100vw;
  height: 100vh;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.language-btns {
  display: flex;
  flex-direction: column;
}

.language-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 20px;

  &:hover,
  &:active,
  &:focus {
    .language-btn__image {
      box-shadow: rgba(0, 0, 0, 0.5) 0 1px 5px;
    }
  }
}

.language-btn__image {
  width: 12.5vh;
  height: 12.5vh;
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 10px;
  background-image: url("~@/assets/images/flags/it.svg");
  margin-right: 20px;
  border: 4px solid white;
}

.language-btn__image--es {
  background-image: url("~@/assets/images/flags/es.svg");
}
.language-btn__image--it {
  background-image: url("~@/assets/images/flags/it.svg");
}
.language-btn__image--en {
  background-image: url("~@/assets/images/flags/en.svg");
}
.language-btn__image--fr {
  background-image: url("~@/assets/images/flags/fr.svg");
}
.language-btn__image--de {
  background-image: url("~@/assets/images/flags/de.svg");
}
.language-btn__image--nl {
  background-image: url("~@/assets/images/flags/nl.svg");
}

.language-btn__text{
  font-weight: bold;
  font-size: 24px;
}
</style>
